import React from "react"
import { BiLinkAlt } from "react-icons/bi"

export default function Achievement({ title, link, header, content, author }) {
    return (
        <section>
            <div className="header">
                <a href={link} target="_blank" rel="noreferrer">
                    {link ? <BiLinkAlt fontSize={28} /> : ""}
                    <h3>{title}</h3>
                    {/* <p>hidden</p> */}
                </a>
            </div>

            <div className="content">
                <h4>{header ? "\"" : ""}{header}</h4>
                <p>{header ? "" : "\""}{content}"</p>
                <div className="author">
                    <div className="horizontal-line"></div>
                    <p>{author}</p>
                </div>
            </div>
        </section>
    )
}
